import { dayjs } from "@lib";

export function formatLastUpdate(value: string | null): string {
	if (!value) {
		return "-";
	}

	return dayjs(value).format("DD/MM/YYYY HH:mm");
}
